import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import axios from 'axios'; // eslint-disable-line import/no-extraneous-dependencies
import * as types from '../constants/ActionTypes';

import { isUsingHardcodeEmailForm, setURLQuery } from '../../lib/page';
import { topicSearchPool, getTopicId } from '../../lib/crawlSearchHelper';
import { getSearchObject } from './action-crawl-intent-topic';
import { fetchFormElementsNoIntent } from './action-email-no-intent';
import { trackPage } from '../../lib/analytics-helper';
import { chatType } from '../constants/UtilVariables';

const TOPIC_TREE_URL = '/smarthelp/topic-tree';
const hardcodeGroupEmail = 'groupEmail';

const TOPIC_MESSAGE = 'topictree request canceled';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();


function requestTopicTreeData() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTreeData(options = {}) {
  if (options.email || options.logoutEmail) {
    // FPTI tracking for topic tree in EmailByPass page
    trackPage({ id: 'emailByPassPage', link: 'smarthelp-email-us' });
  }

  return {
    type: types.RECEIVE_TOPIC_TREE_RESPONSE,
    payload: options.topicTree,
  };
}

function receiveTopicTreeDataError(options = {}) {
  if (options.email || options.logoutEmail) {
    // FPTI tracking error for no topic tree in EmailByPass page
    trackPage({ id: 'emailByPassPageError', link: 'smarthelp-topic-tree-data-error' });
  }
  return dispatch => dispatch({
    type: types.RECEIVE_TOPIC_TREE_ERROR,
    payload: true,
  });
}

function updateLogoutFormTopicName(topicInfo) {
  return {
    type: types.UPDATE_LOGOUT_EMAIL_TOPIC,
    payload: topicInfo,
  };
}

function getTopicTreeUrl() {
  if (!isUsingHardcodeEmailForm()) {
    return TOPIC_TREE_URL;
  }
  return setURLQuery(TOPIC_TREE_URL, hardcodeGroupEmail, 'true');
}

function fetchTopicTree(options) {
  return (dispatch, getState) => {
    dispatch(requestTopicTreeData());
    return axios.get(getTopicTreeUrl(), {
      cancelToken: source.token,
    })
      .then((response) => {
        const topicTree = _get(response.data, 'topicTree.contact_email_template', {});
        const subtopics = topicTree && topicTree.sub_topics;
        if (Array.isArray(subtopics) && subtopics.length > 0) {
          const params = Object.assign({}, options, { topicTree });
          dispatch(receiveTopicTreeData(params));
          const searchPool = topicSearchPool(topicTree);

          if (options && options.logoutEmail) {
            // Logout Email form topic tree for getting topic id
            const topicInfo = getTopicId({ query: options.emailRef, searchPool });
            if (!_isEmpty(topicInfo)) { // Not Topic Id, when the RefId find
              dispatch(fetchFormElementsNoIntent(topicInfo.topic_id, true));
              dispatch(updateLogoutFormTopicName(topicInfo));
            } else {
              dispatch(receiveTopicTreeDataError(options));
            }
          } else {
            // No fetch search object for chatBot final topic intent
            const modalChannel = _get(getState(), 'modal.channel');
            const modalTopic = _get(getState(), 'modal.topic');

            if ((modalChannel === chatType.chatBot || modalChannel === chatType.liveChat) && !_isEmpty(modalTopic)) {
              return null;
            }

            // Fetch Search pool for the Channel Steering page
            dispatch(getSearchObject(searchPool)); // Getting intent topic search pool
          }
        } else {
          dispatch(receiveTopicTreeDataError(options));
        }
        return true;
      })
      .catch((error) => {
        if (error && error.message !== TOPIC_MESSAGE) {
          dispatch(receiveTopicTreeDataError(options));
        }
      });
  };
}

function cancelTopicTreeRequest() {
  source.cancel(TOPIC_MESSAGE);
}

module.exports = {
  fetchTopicTree,
  cancelTopicTreeRequest,
};
